export default __webpack_public_path__ + "static/media/property_855.8006fa89.png";